export function scaleUpCurrency(marks, value) {
  const step = 10;
  const previousMarkIndex = Math.floor(value / step);
  const previousMark = marks[previousMarkIndex];
  const remainder = value % step;
  if (remainder === 0) {
    return previousMark.scaledValue;
  }
  const nextMark = marks[previousMarkIndex + 1];
  const increment = (nextMark.scaledValue - previousMark.scaledValue) / step;
  const newValue = remainder * increment + previousMark.scaledValue;
  return newValue;
}

export function scaleDownCurrency(marks, value) {
  let previousMarkIndex = marks.findIndex((x) => x.scaledValue > value) - 1;
  if (previousMarkIndex < 0) {
    return marks[marks.length - 1].value;
  }
  const previousMark = marks[previousMarkIndex];
  const nextMark = marks[previousMarkIndex + 1];

  const step = nextMark.scaledValue - previousMark.scaledValue;

  const remainder = value % step;
  if (remainder === 0) {
    return previousMark.value;
  }
  const increment = (nextMark.value - previousMark.value) / step;
  const newValue = remainder * increment + previousMark.value;
  return newValue;
}

export function valueLabelFormat(options) {
  if (options.formatter === "currency") {
    return function (num) {
      let value = "";
      if (num > 999 && num < 1000000) {
        value = "$" + (num / 1000).toFixed(0) + "K";
      } else if (num >= 1000000) {
        value = "$" + (num / 1000000).toFixed(0) + "M";
      } else if (num < 900) {
        value = num;
      }
      return value + " or more";
    };
  } else if (options.formatter === "confidenceScoreRange") {
    return function (num) {
      if (num === 10) {
        return num;
      } else if (num < 10) {
        return num + " or more";
      }
    };
  } else if (options.formatter === "riskScoreRange") {
    return function (num) {
      if (num === 1) {
        return num;
      } else if (num < 10) {
        return num + " or lower";
      }
    };
  } else if (options.formatter === "globalCreditFormat") {
    return function (num) {
      if (num === 5) {
        return num;
      } else if (num < 10) {
        return num + " or more";
      }
    };
  }

  return function (num, index) {
    if (Array.isArray(options)) {
      return num + options[index].append;
    } else {
      return num + options.append;
    }
  };
}
